import {
  Field, Form, ErrorMessage, configure, defineRule,
} from 'vee-validate';
import {
  between,
  integer,
  max,
  min,
  min_value as minValue,
  numeric,
  required,
} from '@vee-validate/rules';

defineRule('required', required);
defineRule('numeric', numeric);
defineRule('integer', integer);
defineRule(
  'decimal',
  (value) => value === '' || value == null || /^-?\d+(\.\d+)?$/.test(String(value)),
);
defineRule('min', min);
defineRule('max', max);
defineRule('between', between);
defineRule('min_value', minValue);

configure({
  validateOnBlur: true,
  validateOnChange: true,
  validateOnInput: true,
  validateOnModelUpdate: true,
  generateMessage({ field, rule }) {
    const [first, second] = Array.isArray(rule?.params) ? rule.params : [];
    const messages = {
      required: `The ${field} field is required.`,
      numeric: `The ${field} field may only contain numeric characters.`,
      integer: `The ${field} field must be an integer.`,
      decimal: `The ${field} field must be numeric.`,
      min: `The ${field} field must be at least ${first} characters.`,
      max: `The ${field} field may not be greater than ${first} characters.`,
      min_value: `The ${field} field must be ${first} or more.`,
      between: `The ${field} field must be between ${first} and ${second}.`,
    };
    return messages[rule?.name] || `The ${field} field is not valid.`;
  },
});

export { ErrorMessage, Field, Form };
